import { OperationTransforms } from '../../ot-slate-v2';
import type { Editor } from 'slate';
import type { EditorPlugin, MetadataOperation } from '../../types/aha-editor';
import History from '../../collaboration/History';

export function handleAddMetadata(editor: Editor, op: MetadataOperation) {
  History.withoutUndoSaving(editor, () => {
    OperationTransforms.AddMetadata(editor, op);
  });

  return false;
}

export function handleRemoveMetadata(editor: Editor, op: MetadataOperation) {
  if (op.type !== 'remove_metadata') return false;

  History.withoutUndoSaving(editor, () => {
    OperationTransforms.RemoveMetadata(editor, op);
  });

  return false;
}

export function handleSetMetadata(editor: Editor, op: MetadataOperation) {
  History.withoutUndoSaving(editor, () => {
    OperationTransforms.SetMetadata(editor, op);
  });

  return false;
}

const MetadataOperationsHandler: EditorPlugin = {
  name: 'MetadataPlugin',
  operationHandlers: [
    {
      operation: 'add_metadata',
      run: handleAddMetadata,
    },
    {
      operation: 'remove_metadata',
      run: handleRemoveMetadata,
    },
    {
      operation: 'set_metadata',
      run: handleSetMetadata,
    },
  ],
};

export default MetadataOperationsHandler;
